import React, { useEffect, useState } from "react";
import "./verificationcode.scss";
import { toast } from "react-toastify";
import { useAuthenticateCustomerViaOtpMutation } from "../../../Services/eurocustomer/EuroCustomer";
import { CUST_ID } from "../../../constants";
import { Loader } from "react-bootstrap-typeahead";
import axios from "axios";
import FeedbackModal from "../../../pages/customerPprofile/FeedbackModal";

interface IPROPS {
  input: any;
  setOpenLoginModal: any;
  resendOtp: any;
  fetchVehicles: any;
  setIsOtpVerified: any;
  setOpenModal: any;
  loading: any;
  isEmailSelected: boolean;
}

const CustomerOTPPage: React.FC<IPROPS> = ({
  loading,
  input,
  setOpenLoginModal,
  resendOtp,
  fetchVehicles,
  setIsOtpVerified,
  setOpenModal,
  isEmailSelected,
}) => {
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const [customerLogin, setCustomerLogin] = useState(true);
  const [loader, setLoader] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [feedbackData, setFeedbackData] = useState<any>({});

  // Timer states for resend OTP
  const [resendTimer, setResendTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);
  const [verfiyOtpTrigger, { status }] =
    useAuthenticateCustomerViaOtpMutation();

  useEffect(() => {
    setLoader(status === "pending");
  }, [status]);

  // Timer effect for resend OTP
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (resendTimer > 0) {
      setCanResend(false);
      interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [resendTimer]);

  const handleChange = (index, value) => {
    if (value.length > 1) return;

    const updatedOtp = [...otpValues];
    updatedOtp[index] = value;
    setOtpValues(updatedOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace for better UX
    if (e.key === "Backspace") {
      const updatedOtp = [...otpValues];

      // If current field has value, clear it
      if (updatedOtp[index]) {
        updatedOtp[index] = "";
        setOtpValues(updatedOtp);
      }
      // If current field is empty, move to previous field and clear it
      else if (index > 0) {
        const prevInput = document.getElementById(`otp-${index - 1}`);
        if (prevInput) {
          updatedOtp[index - 1] = "";
          setOtpValues(updatedOtp);
          prevInput.focus();
        }
      }
      e.preventDefault();
    }

    // Handle arrow key navigation
    if (e.key === "ArrowRight" && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }

    if (e.key === "ArrowLeft" && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const authenticateHandler = async () => {
    const otp = otpValues.join("");
    if (otp.length !== 6) {
      alert("Please enter a valid 6-digit OTP");
      return;
    }

    const payloadObj = {
      identifier: input,
      otp: otp,
      user_platform: "web",
    };

    try {
      const response = await verfiyOtpTrigger(payloadObj);

      if (response?.data) {
        localStorage.setItem("customer-token", response.data.access_token);
        localStorage.setItem("login-type", JSON.stringify(response.data.user));
        localStorage.setItem(CUST_ID, response.data.user.id);
        toast.success("Otp verified successfully");
        fetchVehicles();
        setIsOtpVerified(true);
        setOpenModal("");

        // Check current location and navigate accordingly
        const currentPath = window.location.pathname;
        if (currentPath.includes("customer/service")) {
          // Navigate to vehicle/select if currently on customer/service
          window.location.href = "/vehicle/select";
        }
      } else if (
        response?.error &&
        typeof response.error === "object" &&
        "data" in response.error
      ) {
        const errorData = response.error as { data?: { error?: string } };
        if (errorData.data?.error) {
          toast.error(errorData.data.error);
        }
      }

      localStorage.setItem("customer", customerLogin ? "true" : "false");
    } catch (error) {
      console.error("Verification failed:", error);
    }
  };

  const resendOtpHandler = async () => {
    if (!canResend) return;

    setOtpValues(["", "", "", "", "", ""]);

    try {
      await resendOtp();
      // Start timer after successful resend
      setResendTimer(30);
    } catch (error: any) {
      console.log("Resend OTP Error:", error);

      // Handle 429 error specifically
      if (error?.response?.status === 429) {
        const errData = error?.response?.data || error?.data || error;

        if (errData && errData.retry_after) {
          setResendTimer(errData.retry_after);
          toast.error(
            `Please wait ${errData.retry_after} seconds before requesting another OTP.`
          );
        } else {
          // Fallback to default 30 seconds if retry_after is not provided
          setResendTimer(30);
          toast.error("Please wait before requesting another OTP.");
        }
      } else {
        // Handle other error types
        const errData = error?.response?.data || error?.data || error;

        if (
          errData &&
          errData.error === "Please wait before requesting another OTP." &&
          typeof errData.retry_after === "number"
        ) {
          setResendTimer(errData.retry_after);
          toast.error(
            `Please wait ${errData.retry_after} seconds before requesting another OTP.`
          );
        } else {
          toast.error("Failed to resend OTP. Please try again later.");
        }
      }
    }
  };

  const customerid = localStorage.getItem(CUST_ID);
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const token = localStorage.getItem("customer-token");

  const fetchServiceRequestAPI = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/appointment-list/?customer_id=${customerid}&status=completed`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBookingData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    if (customerid && token) {
      fetchServiceRequestAPI();
    }
  }, [customerid, token]);

  useEffect(() => {
    const entryToFeedback = bookingData.find(
      (item) => item.customer_feedback === null && item.customer_rating === null
    );

    if (entryToFeedback) {
      setFeedbackData(entryToFeedback);
      setOpenFeedback(true);
    }
  }, [bookingData]);

  return (
    <div className="verification-container" style={{ padding: "0" }}>
      <h2>Verification Code</h2>
      <p className="instruction">
        Enter the verification code sent to your{" "}
        {isEmailSelected ? "email address" : "mobile number"}.
      </p>

      <div className="code-inputs" style={{ gap: "5px" }}>
        {otpValues.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            type="number"
            maxLength={1}
            value={digit}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              handleChange(index, value);
            }}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={(e) => {
              e.preventDefault();
              const pastedData = e.clipboardData
                .getData("text")
                .replace(/\D/g, "");
              if (pastedData.length <= 6) {
                const newOtp = Array(6).fill("");
                for (let i = 0; i < Math.min(pastedData.length, 6); i++) {
                  newOtp[i] = pastedData[i];
                }
                setOtpValues(newOtp);
                // Focus on the next empty field or last field
                const nextIndex = Math.min(pastedData.length, 5);
                const nextInput = document.getElementById(`otp-${nextIndex}`);
                if (nextInput) nextInput.focus();
              }
            }}
          />
        ))}
      </div>

      <button className="confirm-btn" onClick={authenticateHandler}>
        {loader ? (
          <>
            Confirming...
            <Loader />
          </>
        ) : (
          "Confirm"
        )}
      </button>

      <button
        className="resend-code"
        onClick={resendOtpHandler}
        disabled={!canResend || loading === "pending"}
        style={{
          opacity: !canResend || loading === "pending" ? 0.6 : 1,
          cursor:
            !canResend || loading === "pending" ? "not-allowed" : "pointer",
        }}
      >
        {loading === "pending" ? (
          <>
            Sending OTP...
            <Loader />
          </>
        ) : !canResend ? (
          `Resend Code (${resendTimer}s)`
        ) : (
          "Resend Code"
        )}
      </button>

      <FeedbackModal
        show={openFeedback}
        onClose={() => {
          setOpenModal("");
          setOpenFeedback(false);
        }}
        getServiceData={feedbackData}
        fetchServiceRequestAPI={fetchServiceRequestAPI}
        setOpenModal={setOpenModal}
      />
    </div>
  );
};

export default CustomerOTPPage;
